// ----- CSS imports -----//
import './../css/main.scss';


// ------ custom imports ------//
import classicAccount from "./custom/customer/account";
import { headerSticky } from "./custom/sticky";
import { emailSignup } from "./custom/form/emailSignup";
import { html5FormValidate } from "./custom/form/js-validation";
import { disableSubmitButton } from "./custom/form/disableSubmit";
import { globalFunctions } from "./custom/utils/global";
import { simpleModal } from "./custom/utils/modals";
import { inputMask } from "./custom/form/inputs";
import {
    loginToggle,
    passwordToggle,
    simpleToggle
} from "./custom/utils/toggles";
import {
    mobileFiltering,
    selectedFilters,
    selectedFilterLoading
} from "./custom/category";

import 'slick-carousel';

import { 
    youtubeFunctions,
    youtubeStateChangeFunctions
} from "./custom/youtube";

// jQuery imports
import $ from 'jquery';
jQuery.noConflict();

// Functions that get called from layout and php files so they need to be available globally
// window.$ = jQuery;
window.cfAccount = classicAccount;
window.disableSubmitButton = disableSubmitButton;
window.simpleToggle = simpleToggle;
window.html5FormValidate = html5FormValidate;

// ------ misc scripts  ------ //\

// On Ready
jQuery(function($) {
    // Call individual functions on doc ready
    globalFunctions();
    html5FormValidate();
    // headerSticky();
    loginToggle();
    passwordToggle();
    simpleToggle();
    simpleModal();
    inputMask();
    selectedFilterLoading();
    youtubeFunctions();  
    // Function to only fire layered nav code mods on window size less than 768. Listener is for someone changing window size on desktop. ALS
    let isSmallScreen = false;

    function handleResize() {
        if (window.innerWidth < 768 && !isSmallScreen) {
            mobileFiltering();
            isSmallScreen = true;
        } else if (window.innerWidth >= 768 && isSmallScreen) {
            isSmallScreen = false;
        }
      }

    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
});

$(document.body).on('click', '.btn-newsletter-signup', function (e) {
    e.preventDefault();
    let $this = jQuery(this);
    emailSignup($this);
});

$(window).on('load resize scroll orientationchange', function () {
    headerSticky();
    youtubeStateChangeFunctions();
});